import { v4 as uuidv4 } from "uuid";
import { mapMutations, mapState } from "vuex";

import ModalTaxInformation from "../../components/ModalTaxInformation/Index-TaxInformation.vue";
import ModalCreateCategory from "../../components/Modals/ModalCreateCategory.vue"
import ModalCreateNcm from "../../components/Modals/ModalCreateNcm.vue"
import ProductsComposition from "../../components/ProductsComposition/ProductsComposition.vue"
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue"
import InputInfinit from "../../components/UI/CustomInputs/InputInfinit.vue"
import InputQuant from "../../components/UI/CustomInputs/InputQuant.vue"

import toastAlertErros from "../../utils/toastAlertErros";
import ServiceProducts from "../../services/serviceProducts";
import ServiceCategory from "../../services/serviceCategory";
import ServiceTax from "../../services/serviceTax";
import { mascaraMoeda } from "../../utils/maskMoney";
import { removeSpecialCharacters } from "../../utils/removeSpecialCharacters"
import { HandleErrors } from "../../utils/handleErrors"
import { canViewProductCost } from "../../utils/productCostPermission";
import api from "../../services/axios";
import { unidade } from "../../common/index";
import serviceNcms from "../../services/serviceNcms";
const mixinProducts = {
  props: {
    readOrEditProducts: {
      type: Object,
    },
    idProductFromSearch: {
      type: String
    }
  },
  components: {
    ModalTaxInformation,
    ModalCreateCategory,
    ModalCreateNcm,
    ProductsComposition,
    InputSelect,
    InputInfinit,
    InputQuant
  },
  data() {
    return {
      dataProducts: {
        id: "",
        idCategoria: "",
        nome: "",
        custoInicial: 0.0,
        frete: 0.0,
        encargos: 0.0,
        lucro: 0.0,
        valor: 0.0,
        valorVenda: 0.0,
        valorVenda2: 0.0,
        valorVenda3: 0.0,
        margem1: 0,
        margem2: 0,
        margem3: 0,
        unidade: "",
        descricao: "",
        codBarras: "",
        codReferencia: "",
        estoque: 0,
        estoqueMin: 0,
        refFiscal: "",
        cest: "",
        nomeCest: "",
        ncm: "",
        nomeNcm: "",
        status: "Ativo",
        composicao: [],
        localizacao: "",
      },
      dataProviderProducts: {
        idFornecedor: "",
        idProduto: "",
        estoque: "",
        valorUnitario: "",
        valorTotal: "",
        descricao: "",
      },
      supplierForSelectBox: [],
      refsFiscais: [],
      createdNewRef: false,
      reloadNcms: false,
      cests: [],
      categories: [],
      stockAdjustmentIsEnable: false,
      stockAmount: 0,
      getProducts: false,
      status: [
        { value: "Ativo", text: "Ativo" },
        { value: "Inativo", text: "Inativo" },
      ],
      compositionIsEnaled: false,
      clearComposition: false,
      unidade: unidade,
      percentFrete: 0,
      percentEncargos: 0,
      codProd: '',
      isLoading: false,
    };
  },
  methods: {
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_PRODUCT",
    ]),
    saveOrUpdateProducts() {
      this.handleComposition()

      this.dataProducts.id === "" || this.dataProducts.id === null
        ? this.saveProducts()
        : this.updateProducts();
    },

    async updateProducts() {
      try {
        this.isLoading = true
        await ServiceProducts.updateProducts(this.dataProducts);
        if (this.dataProviderProducts.idFornecedor) {
          await this.assingProviderProduct(this.dataProducts);
        }
        this.$emit("getAllProducts", this.getProducts);
        this.getProducts = !this.getProducts;
        this.SET_IS_SEARCH_REGISTERS();
        this.clear();
        return this.$toast.open({
          message: "Produto Atualizado com Sucesso",
          type: "success",
        });

      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }
        else {
          toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
        }
      } finally {
        this.isLoading = false
      }
    },

    async saveProducts() {
      try {
        this.isLoading = true

        if (this.dataProducts.nome !== "") {
          const id = await ServiceProducts.saveProducts(this.dataProducts);
          this.dataProducts.id = id;
          if (this.dataProviderProducts.idFornecedor) {
            await this.assingProviderProduct(this.dataProducts);
          }

          this.findCestGrupBy();
          this.reloadNcms = !this.reloadNcms;

          this.$emit("getAllProducts", this.getProducts);
          this.getProducts = !this.getProducts;
          this.SET_IS_SEARCH_REGISTERS();
          this.clear();
          return this.$toast.open({
            message: "Produto Salvo com Sucesso",
            type: "success",
          });
        } else {
          return this.$toast.open({
            message: "Nome do produto é OBRIGATÓRIO!",
            type: "info",
          });
        }
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }
        else if (!isNaN(error.response.data.erros)) {
          toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
        } else {
          this.$toast.open({
            message: error?.response?.data?.message || "Ocorreu um problema ao registrar o produto!",
            type: "info",
          });
        }
      } finally {
        this.isLoading = false
      }
    },

    async handleStockAdjustment() {
      this.$bvModal.hide('modal-ajustStock')

      if (!this.dataProducts.id) {
        this.dataProducts.estoque = this.stockAmount
        this.closeStockAdjustment();
      } else {
        await this.stockAdjustment()
        this.closeStockAdjustment()
      }
    },

    handleComposition() {
      this.dataProducts.composicao = this.dataProducts.composicao.filter(item => item.idProduto)
    },

    async stockAdjustment() {
      this.dataProducts.estoque = this.stockAmount
      await this.updateProducts()
    },

    enableStockAdjustment() {
      this.stockAdjustmentIsEnable = true
    },

    closeStockAdjustment() {
      this.stockAdjustmentIsEnable = false
      this.stockAmount = 0
    },

    async fillRefsFiscaisComboBoxWithPaginate(id, q, filterType, page) {
      try {
        const result = await ServiceTax.fillComboBoxWithPaginate(id, q, filterType, page);
        return result.map((e) => ({ ...e, nomeRef: `${e.ref} - ${e.descricao}` }));
      } catch (error) {
        this.$toast.open({
          message: error?.response?.data?.message || "Ocorreu um problema ao buscar as referências fiscais",
          type: "info"
        })
      }
    },

    async findCestGrupBy() {
      const result = await ServiceProducts.findCestGrupBy()
      this.cests = [
        {
          nomeCest: 'Selecione',
          cest: ''
        },
        ...result
      ]
    },

    async findAllCategories() {
      try {
        this.categories = await ServiceCategory.fillComobobox()
      } catch (error) {
        this.$toast.open({
          message: error?.response?.data?.message || "Ocorreu um problema ao buscar as categorias do produto",
          type: "info"
        })
      }
    },

    async fillNcmComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await serviceNcms.fillComboBoxWithPaginate(id, q, filterType, page)
      } catch (error) {
        this.$toast.open({
          message: error?.response?.data?.message || "Ocorreu um problema ao buscar os ncms do produto",
          type: "info"
        })
      }
    },

    async findById(id) {
      const product = await ServiceProducts.getProductById(id)
      return product
    },

    async handleModalCreateProduct() {
      const product = await this.findById(this.idProductFromSearch)
      this.SET_DATA_SEARCH_FROM_PRODUCT(product)
      this.assingEditProduct();
    },

    clear() {
      this.dataProducts = {
        id: "",
        nome: "",
        valor: 0.0,
        valorVenda: 0.0,
        valorVenda2: 0.0,
        valorVenda3: 0.0,
        custoInicial: 0.0,
        frete: 0.0,
        encargos: 0.0,
        lucro: 0.0,
        margem1: 0,
        margem2: 0,
        margem3: 0,
        unidade: "",
        descricao: "",
        codBarras: "",
        localizacao: "",
        codReferencia: "",
        estoque: 0,
        estoqueMin: 0,
        ncm: "",
        refFiscal: "",
        status: "Ativo",
        composicao: [],
        idCategoria: "",
      };
      this.percentEncargos = 0
      this.percentFrete = 0
      this.$refs.refCategories.valueItems = ""
      this.clearComposition = !this.clearComposition
      this.codProd = ""

      this.SET_DATA_SEARCH_FROM_PRODUCT({})
    },

    handleNcmOrCest(value, isNcm = false) {
      const formattedValue = removeSpecialCharacters(value)

      if (isNcm) this.dataProducts.ncm = formattedValue
      else this.dataProducts.cest = formattedValue

      return formattedValue
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    maskCurrency(valor, locale = "pt-BR") {
      if (!valor) {
        valor = 0;
      }
      return parseFloat(valor).toLocaleString(locale, {
        style: "currency",
        currency: "BRL",
      });
    },

    maskPercentage(valor, locale = "pt-BR") {
      if (!valor) {
        valor = 0;
      }

      return `% ${parseFloat(valor)
        .toLocaleString(locale, {
          minimumFractionDigits: 2,
        })
        .replace(",", ".")}`;
    },

    formatMoney(event, value) {
      this.dataProducts[value] = mascaraMoeda(event);

      this.$nextTick(() => [
        this.handleCalculate(event, value)
      ])
    },

    formatPercente(event, value) {
      this[value] = mascaraMoeda(event);
    },

    formatPercenteProd(event, value) {
      this.dataProducts[value] = mascaraMoeda(event);
    },

    handleCalculate(event, value) {
      if (value === 'valor') {
        this.dataProducts.valorVenda = mascaraMoeda(event);
        this.dataProducts.valorVenda2 = mascaraMoeda(event);
        this.dataProducts.valorVenda3 = mascaraMoeda(event);
      }

      if (value === 'margem1' || value === 'lucro') {
        this.dataProducts.valorVenda = this.dataProducts.lucro + this.dataProducts.valor;
      } else if (value === 'margem2') {
        const result = (this.dataProducts.valor * this.dataProducts.margem2) / 100;
        this.dataProducts.valorVenda2 = result + this.dataProducts.valor
      } else if (value === 'margem3') {
        const result = (this.dataProducts.valor * this.dataProducts.margem3) / 100;
        this.dataProducts.valorVenda3 = result + this.dataProducts.valor
      }
    },

    assingEditProduct() {
      this.dataProducts.id = this.dataSearchProduct.id
      this.dataProducts.idCategoria = this.dataSearchProduct.idCategoria
      this.dataProducts.nome = this.dataSearchProduct.nome
      this.dataProducts.valor = this.dataSearchProduct.valor || 0
      this.dataProducts.valorVenda = this.dataSearchProduct.valorVenda || 0
      this.dataProducts.valorVenda2 = this.dataSearchProduct.valorVenda2 || 0
      this.dataProducts.valorVenda3 = this.dataSearchProduct.valorVenda3 || 0
      this.dataProducts.margem1 = this.dataSearchProduct.margem1 || 0
      this.dataProducts.margem2 = this.dataSearchProduct.margem2 || 0
      this.dataProducts.margem3 = this.dataSearchProduct.margem3 || 0

      this.dataProducts.custoInicial = this.dataSearchProduct.custoInicial || 0
      this.dataProducts.frete = this.dataSearchProduct.frete || 0
      this.dataProducts.encargos = this.dataSearchProduct.encargos || 0
      this.dataProducts.lucro = this.dataSearchProduct.lucro || 0
      this.dataProducts.unidade = this.dataSearchProduct.unidade
      this.dataProducts.descricao = this.dataSearchProduct.descricao
      this.dataProducts.codBarras = this.dataSearchProduct.codBarras
      this.dataProducts.localizacao = this.dataSearchProduct.localizacao
      this.dataProducts.codReferencia = this.dataSearchProduct.codReferencia
      this.dataProducts.estoque = this.dataSearchProduct.estoque
      this.dataProducts.estoqueMin = this.dataSearchProduct.estoqueMin
      this.dataProducts.refFiscal = this.dataSearchProduct.refFiscal
      this.dataProducts.nomeNcm = this.dataSearchProduct.nomeNcm
      this.dataProducts.ncm = this.dataSearchProduct.ncm
      this.dataProducts.nomeCest = this.dataSearchProduct.nomeCest
      this.dataProducts.cest = this.dataSearchProduct.cest || ''
      this.dataProducts.status = this.dataSearchProduct.status

      this.codProd = this.dataSearchProduct.codigo

      this.$refs.refCategories.valueItems = this.dataSearchProduct.idCategoria

      if (this.dataSearchProduct.composicao && this.dataSearchProduct.composicao.length) {
        this.dataProducts.composicao = this.dataSearchProduct.composicao.map(composition => {
          return {
            ...composition,
            idList: uuidv4()
          }
        })

        this.compositionIsEnaled = true
      }
    },

    async assingProviderProduct(product) {
      this.dataProviderProducts.idProduto = this.dataProducts.id
      this.dataProviderProducts.valorUnitario = product.valorVenda
      this.dataProviderProducts.valorTotal = product.valorVenda
      this.dataProviderProducts.descricao = product.descricao
      this.dataProviderProducts.estoque = product.estoque
      await api.post('/products-by-provider', this.dataProviderProducts)
    },

    toggleEnableComposition() {
      this.compositionIsEnaled = !this.compositionIsEnaled
    },
  },
  watch: {
    readOrEditProducts() {
      this.dataProducts = this.readOrEditProducts;
    },
    valorFrete(newValue) {
      if (this.canViewProductCost) this.dataProducts.frete = newValue;
    },
    valorEncargos(newValue) {
      if (this.canViewProductCost) this.dataProducts.encargos = newValue;
    },
    valorCustoFinal(newValue) {
      if (this.canViewProductCost) this.dataProducts.valor = newValue;
    },
    valorMargemLucro(newValue) {
      if (this.canViewProductCost) this.dataProducts.lucro = newValue;
    },
  },
  async mounted() {
    if (this.dataSearchProduct.id) {
      this.assingEditProduct();
    } else if (this.idProductFromSearch) {
      this.handleModalCreateProduct()
    }

    await this.findCestGrupBy()
    this.findAllCategories()
  },

  computed: {
    ...mapState({
      dataSearchProduct: (state) => state.dataSearchProduct
    }),
    canViewProductCost() {
      return canViewProductCost();
    },
    valorFrete: {
      get() {
        if (this.percentFrete) {
          return (parseFloat(this.dataProducts.custoInicial) * parseFloat(this.percentFrete)) / 100;
        }
        return this.dataProducts.frete;
      },
      set(value) {
        this.dataProducts.frete = value;
      }
    },
    valorEncargos: {
      get() {
        if (this.percentEncargos) {
          return (parseFloat(this.dataProducts.custoInicial) * parseFloat(this.percentEncargos)) / 100;
        }
        return this.dataProducts.encargos;
      },
      set(value) {
        this.dataProducts.encargos = value;
      }
    },
    valorCustoFinal: {
      get() {
        let custoInicial = parseFloat(this.dataProducts.custoInicial) || 0;
        let frete = parseFloat(this.dataProducts.frete) || 0;
        let encargos = parseFloat(this.dataProducts.encargos) || 0;

        return custoInicial + frete + encargos;
      },
      set(value) {
        this.dataProducts.valor = value;
      }
    },
    valorMargemLucro: {
      get() {
        let valorCustoFinal = parseFloat(this.dataProducts.valor) || 0;

        const value = this.dataProducts.margem1
          ? (valorCustoFinal * parseFloat(this.dataProducts.margem1)) / 100
          : this.dataProducts.lucro

        return value;
      },
      set(value) {
        this.dataProducts.lucro = value;
      }
    }
  },

  beforeDestroy() {
    this.clear();
  }
}

export default mixinProducts
